<template>
  <el-dialog
    :visible="NDAUploadVisible"
    width="780px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    custom-class="NDAdialog"
    center
    :show-close="false"
  >
    <template slot="title">
      <div class="explain">
        <p>
          <i class="iconfont icon-error-circle-filled"></i
          >当前询盘需要你接受以下保密协议后，才能查阅图纸
        </p>
        <i
          class="iconfont icon-close cp"
          style="color: #999999"
          @click="$emit('changeVisible', false)"
        ></i>
      </div>
    </template>
    <div class="NDAtitle">保密协议</div>
    <div class="NDADialogContent">
      <p class="title">查看系统默认保密协议</p>
      <div class="agreementList">
        <template v-if="!customFileList.length">
          <div class="agreementItem">
            <a
              class="left"
              href="https://res.haizol.com/base/docs/nda_en.pdf"
              target="_blank"
            >
              <img
                src="@/assets/image/zhenyun/PDF-icon.png"
                alt=""
                style="height: 24px"
              />
              <span class="agreementName">English Download</span>
            </a>
            <i
              class="icon-download iconfont cp"
              style="color: #98a3b7"
              @click="
                handleDownloadPDF(
                  'https://res.haizol.com/base/docs/nda_en.pdf',
                  'en'
                )
              "
            ></i>
          </div>
          <div class="agreementItem">
            <a
              class="left"
              href="https://res.haizol.com/base/docs/nda_cn.pdf"
              target="_blank"
            >
              <img
                src="@/assets/image/zhenyun/PDF-icon.png"
                alt=""
                style="height: 24px"
              />
              <span class="agreementName">中文下载</span>
            </a>
            <i
              class="icon-download iconfont cp"
              style="color: #98a3b7"
              @click="
                handleDownloadPDF(
                  'https://res.haizol.com/base/docs/nda_cn.pdf',
                  'cn'
                )
              "
            ></i>
          </div>
        </template>
        <template v-else>
          <div
            class="agreementItem"
            v-for="(attItem, attIndex) in customFileList"
            :key="attIndex"
          >
            <a
              class="left"
              :href="onlineUrl + '/' + attItem.previewUrl"
              target="_blank"
            >
              <img
                src="@/assets/image/zhenyun/PDF-icon.png"
                alt=""
                style="height: 24px"
              />
              <span class="agreementName">{{ attItem.originalName }}</span>
            </a>
            <i
              class="icon-download iconfont cp"
              style="color: #98a3b7"
              @click="handleDownloadFile(attItem)"
            ></i>
          </div>
        </template>
      </div>
      <div class="uploadAgreement">
        <p class="title">附件</p>
        <el-upload
          ref="upload"
          :action="onlineUrl + '/mk-rfq-api/common/attach/upload'"
          :data="paramsupload"
          :withCredentials="true"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :on-error="handleError"
          :on-success="handleSuccess"
          :accept="acceptTypes"
          multiple
          :file-list="agreementFileList"
          v-loading="uploadLoading"
        >
          <div class="customUploadStyle">
            <p class="uploadTitle">
              <i class="iconfont icon-upload1 mr5"></i>
              <span>上传附件</span>
            </p>
            <p class="uploadDesc">
              （上传签字后的保密协议，限：PDF｜WORD｜GIF｜JPG｜JPEG｜PNG｜BMP）
            </p>
          </div>
        </el-upload>
      </div>
      <div class="fileListBox" v-if="agreementFileList.length > 0">
        <div
          class="showFileBoxItem"
          v-for="(fileItem, fileIndex) in agreementFileList"
          :key="fileIndex"
        >
          <p class="cp" @click="handleDownloadFile(fileItem, fileIndex)">
            <i class="iconfont icon-attach"></i>
            <span class="fileBoxName">{{ fileItem.name }}</span>
          </p>
          <i
            class="iconfont icon-close cp"
            style="color: #98a3b7"
            @click="handleDelete(fileIndex)"
          ></i>
        </div>
      </div>
      <div class="uploadAgreement">
        <p class="title">备注说明</p>
        <el-input
          v-model="remark"
          placeholder="请输入"
          rows="4"
          type="textarea"
          maxlength="200"
          show-word-limit
        ></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        class="acceptBtn"
        @click="handleAcceptNDA2()"
        :loading="submitLoading"
        >提交</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { fileUrl, onlineUrl, companyLogoUrl } from '@/utils/config.js'
import { applyTwoNDAApi } from '@/utils/api/zhenyun.js'
import { getCustomAttachment } from '@/utils/api/zhenyunOrder.js'
export default {
  model: {
    prop: 'visible',
    event: 'changeVisible',
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramsupload: {
        source: 5,
      },
      onlineUrl: onlineUrl,
      agreementFileList: [],
      remark: '',
      // 允许的文件扩展名
      acceptTypes: '.pdf,.doc,.docx,.gif,.jpg,.jpeg,.png,.bmp',
      uploadLoading: false,
      submitLoading: false,
      customFileList: [],
    }
  },
  computed: {
    NDAUploadVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('changeVisible', val)
      },
    },
  },
  methods: {
    async handleDownloadFile(fileItem){
      const response = await fetch(fileItem.url)
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileItem.originalName // 强制下载
      link.click()
      // 释放内存
      setTimeout(() => URL.revokeObjectURL(blobUrl), 100)
    },
    handleDownloadFile(item, index) {
      const a = document.createElement('a')
      a.href = `${onlineUrl}${item.url}`
      a.target = '_blank'
      a.download = item.name || 'download' // 设置下载文件名
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleDelete(index) {
      this.agreementFileList.splice(index, 1)
    },
    async handleDownloadPDF(url, type) {
      const response = await fetch(url)
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `nda_${type}.pdf` // 强制下载
      link.click()
      // 释放内存
      setTimeout(() => URL.revokeObjectURL(blobUrl), 100)
    },
    async handleAcceptNDA2() {
      if (!this.agreementFileList.length) {
        return this.$message.error('请上传附件')
      }
      try {
        const params = {
          rfqId: this.id,
          attachment: this.agreementFileList.map((k) => k.hashCode),
          remark: this.remark,
        }
        this.submitLoading = true
        const res = await applyTwoNDAApi(params)
        this.submitLoading = false
        if (res.rspResult.bizCode == 200) {
          this.$message.success('提交成功')
          this.$emit('changeVisible', false)
          this.$emit('changeDetails', 'agree', true)
        }
      } catch (error) {
        this.submitLoading = false
      }
    },
    beforeUpload(file) {
      const fileExtension = file.name.split('.').pop().toLowerCase()
      const allowedExtensions = [
        'pdf',
        'doc',
        'docx',
        'gif',
        'jpg',
        'jpeg',
        'png',
        'bmp',
      ]
      const allowedMimeTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/bmp',
      ]

      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.error(
          '文件格式不支持，请上传 PDF, WORD, GIF, JPG, JPEG, PNG 或 BMP 格式的文件'
        )
        this.uploadLoading = false
        return false
      }
      if (!allowedMimeTypes.includes(file.type)) {
        this.$message.error('文件类型不支持，请上传有效的文件')
        this.uploadLoading = false
        return false
      }
      this.uploadLoading = true
      return true
    },
    handleError() {
      this.$message.error('上传失败，请稍后再试')
      this.uploadLoading = false
    },
    handleSuccess(response, file, fileList) {
      if (response.rspResult.bizCode !== 200) {
        this.$message.error(response.rspResult.message)
      } else if (response.rspResult.bizCode === 200) {
        this.$message.success('上传成功')
        const data = response.data
        this.agreementFileList.push({
          name: file.name,
          ...data,
        })
        console.log(this.agreementFileList, 'this.agreementFileList')
        this.uploadLoading = false
      }
    },
    getAttachment() {
      getCustomAttachment({
        id: this.id,
      }).then((res) => {
        if (res.rspResult.bizCode == 200) {
          this.customFileList = res.rspListData.list
        }
      })
    },
  },
  mounted() {
    this.getAttachment()
  },
}
</script>
<style lang="scss" scoped>
:deep(.NDAdialog) {
  border-radius: 8px;
  font-family: SourceHanSansCN-Regular;
  .NDAtitle {
    color: #222222;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
    margin: 16px 0;
  }
  .el-dialog__header {
    padding: 0px;
    text-align: left;
  }
  .el-dialog__body {
    color: #222222;
    padding: 0px 24px 24px 24px;
  }
  .explain {
    padding: 12px 24px;
    background: #fff9ed;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      color: #ff7800;
      font-size: 16px;
      margin-right: 8px;
      font-weight: 400;
    }
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    color: #73451c;
  }
  .NDADialogContent {
    .title {
      color: #222222;
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .agreementList {
      display: flex;
      flex-direction: column;
      gap: 8px;
      .agreementItem {
        display: flex;
        padding: 8px 16px 8px 8px;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px;
        background: #fbfbfb;
        .left {
          display: flex;
          align-items: center;
          .agreementName {
            color: #0863ff;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            cursor: pointer;
            margin-left: 10px;
          }
        }
      }
    }
    .uploadAgreement {
      margin-top: 24px;
      .title {
        color: #222222;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        line-height: 22px;
      }
      .el-upload {
        width: 100%;
      }
      .customUploadStyle {
        display: flex;
        padding: 12px 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 4px;
        border: 1px dashed #d0e2ff;
        background: #f8faff;
        width: 100%;
        .uploadTitle {
          color: #0863ff;
          font-size: 14px;
          font-weight: 400;
          display: flex;
          align-items: center;
        }
        .uploadDesc {
          color: #98a3b7;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
    .fileListBox {
      display: flex;

      flex-direction: column;
      gap: 8px;

      margin-top: 8px;
      .showFileBoxItem {
        border-radius: 8px;
        padding: 4px 16px 4px 8px;
        background: #fbfbfb;
        color: #0863ff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        line-height: 22px;
        .fileBoxName {
          margin-left: 5px;
        }
      }
    }
  }
  .el-dialog__footer {
    padding-top: 0px;
  }
  .acceptBtn {
    background: #0863ff;
    color: #ffffff;
    border: none;
    width: 92px;
    height: 32px;
    font-size: 14px;
    font-weight: 400;
  }
  .acceptBtn:hover {
    background: #0863ff !important;
    border: none;
  }
}
.mr5 {
  margin-right: 5px;
}
.cp {
  cursor: pointer;
}
</style>
